module.exports = __webpack_public_path__ + "static/media/guide_1.6ce988f7.svg";